import { render } from "./RegionsSearch.vue?vue&type=template&id=500464e4&scoped=true"
import script from "./RegionsSearch.vue?vue&type=script&lang=js"
export * from "./RegionsSearch.vue?vue&type=script&lang=js"

import "./RegionsSearch.vue?vue&type=style&index=0&id=500464e4&lang=scss&scoped=true"
import "./RegionsSearch.vue?vue&type=style&index=1&id=500464e4&lang=scss"
script.render = render
script.__scopeId = "data-v-500464e4"

export default script